// VALIDITY CAPPED BY AN OEM PRICE (validity-cap-from-oem, owner 2026-10-06).
//
// What the finalise confirmation says the quote's Valid-until WILL be, when a
// line takes its cost from an OEM quote that expires before the quote's normal
// validity (finalise date + Settings > Company validity days). A date
// comparison for the message only: the server sets and freezes the real value
// at finalise (anixify.quote._oem_capped_valid_until) by the same rule.
// No validity days set -> no Valid-until at all -> nothing to cap.

import type { Material } from "@/types";

const iso = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

/** The capped Valid-until (ISO date), or null when there is no cap. */
export function oemValidityCap(
  rows: Pick<Material, "discountSource" | "oemQuote">[],
  validityDays: number | null | undefined,
  today: Date = new Date(),
): string | null {
  if (!validityDays || validityDays <= 0) return null;
  const normal = new Date(today.getFullYear(), today.getMonth(), today.getDate() + validityDays);
  const expiries = rows
    .filter((r) => r.discountSource === "oem_quote" && r.oemQuote?.valid_until)
    .map((r) => r.oemQuote!.valid_until as string)
    .sort();
  if (!expiries.length) return null;
  return expiries[0] < iso(normal) ? expiries[0] : null;
}
